import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import configSlice from "./slice/configSlice";
import applicationSlice from "./slice/applicationSlice";
import violationSlice from "./slice/violationSlice";
export const store = configureStore({
  reducer: { user: userSlice, config: configSlice, application: applicationSlice, violation: violationSlice },
});
